import { put, takeEvery } from "redux-saga/effects"
import { get, post } from "helpers/api_helper"
import { showSavingModal, hideSavingModal } from "../actions"
import {
  getPrivateMessageSuccess,
  getPrivateMessageFailed,
  updatePrivateMessageSuccess,
  updatePrivateMessageFailed,
} from "./actions"
import { GET_PRIVATE_MESSAGE, UPDATE_PRIVATE_MESSAGE } from "./actionTypes"
import { showToast } from "utils"

function* getPrivateMessage({ payload: params }) {
  try {
    const response = yield get(`/event/${params?.id}/private-messages/setup`, {
      params: params?.values,
    })
    yield put(getPrivateMessageSuccess(response))
  } catch (error) {
    yield put(getPrivateMessageFailed(error))
  }
}

function* updatePrivateMessage({ payload: params }) {
  try {
    yield put(showSavingModal())
    const response = yield post(
      `/event/${params?.event_id}/private-messages/setup`,
      params
    )
    yield put(updatePrivateMessageSuccess(response))
    yield put(hideSavingModal())
    showToast("success","Data successfully saved!", "Success")
  } catch (error) {
    yield put(updatePrivateMessageFailed(error))
    showToast("error",error,"Error")
  }
}

function* privateMessageSaga() {
  yield takeEvery(GET_PRIVATE_MESSAGE, getPrivateMessage)
  yield takeEvery(UPDATE_PRIVATE_MESSAGE, updatePrivateMessage)
}

export default privateMessageSaga
